import React, { Component } from "react";
import { Accessor } from "IZOX/STATIC";
import PropsType from "prop-types";
import FadeInOutView from "../../../_X/FadeInOutView";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class ZSnackBar extends Component {

  static propTypes = {
    show: PropsType.bool,
    autoHideDuration: PropsType.number,
    onClose: PropsType.func
  };

  static defaultProps = {
    show: false,
    autoHideDuration: 3000,
    onClose: () => {}
  };

  constructor(){
    super();
    this.state = {
      closing: false
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  _onClose = () => {
    let {onClose, autoHideDuration} = this.props;
    if(onClose){
      this.setState({
        closing: true
      }, () => {
        if(this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          if(this.MountFadeView) {
            this.MountFadeView.fadeOut(200);
          }
          if(this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.setState({
              closing: false
            }, () => {
              onClose();
            });
          }, 500);
        }, autoHideDuration);
      });
    } 
  };

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ZSnackBar.defaultProps))){
      this._setAllStates();
      if(!Accessor.IsIdentical(prevProps, this.props, ["show"])){
        let {show} = this.props;
        let {closing} = this.state;
        if(show && !closing){
          if(this.MountFadeView) {
            this.MountFadeView.fadeIn(200);
          }
          this._onClose();
        }
        if(!show && closing){
          if(this.timeout){
            this.setState({
              closing: false
            }, () => {
              clearTimeout(this.timeout);
            });
          }
        }
      }
      
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  };

  onMountFadeView = (callbacks) => {
    this.MountFadeView = callbacks;
  };

  render(){
    let {children} = this.props;
    let style = {
      width: "100%",
      height: "auto",
      alignItems: "center",
      position: "absolute", 
      backgroundColor: "transparent",
      zIndex: 9999,
      overflow: "visible"
    };
    if(SysConfig.Snackbar.position === "bottom"){
      style = {
        ...style,
        bottom: SysConfig.Snackbar.offset
      };
    }else{
      style = {
        ...style,
        top: SysConfig.Snackbar.offset
      };
    }
    return (
      <FadeInOutView 
        onMounted={this.onMountFadeView}
        style={style}>
        {children}
      </FadeInOutView>
    );
  }

}

export default ZSnackBar;
